import { render, staticRenderFns } from "./ClientEventsByProcedure.vue?vue&type=template&id=b29ef552&scoped=true"
import script from "./ClientEventsByProcedure.vue?vue&type=script&lang=js"
export * from "./ClientEventsByProcedure.vue?vue&type=script&lang=js"
import style0 from "./ClientEventsByProcedure.vue?vue&type=style&index=0&id=b29ef552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29ef552",
  null
  
)

export default component.exports